//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '../../../../src/lib/date';
import OwnerBaseinfo from './conmponents/owner-baseinfo';
import OwnerWorkOrders from './conmponents/owner-workOrders';
import OwnerActivity from './conmponents/owner-activity';
import OwnerQuestionnaire from './conmponents/owner-questionnaire';

export default {
    name: 'ownerDetail',
    components: { OwnerQuestionnaire, OwnerActivity, OwnerWorkOrders, OwnerBaseinfo },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            id: 0,
            loading: false,
            ownerInfo: {
                room: {}
            },
            saving: false,
            name: 'name1'
        };
    },
    methods: {
        getOwnerById() {
            if (this.id === 0) {
                return;
            }
            const vm = this;
            vm.loading = true;
            abp.ajax
                .get('/api/services/app/Owner/GetOwnerById?id=' + this.id)
                .then(res => {
                    vm.ownerInfo = {
                        room: {}
                    };
                    vm.ownerInfo = res.data.result;
                    vm.loading = false;
                })
                .finally(() => {
                    vm.loading = false;
                });
        },
        editOwner() {
            this.$router.push({
                name: 'ownerEdit',
                params: { id: this.id }
            });
        },
        onRefresh() {
            if (this.name == 'name1') {

            } else if (this.name == 'name2') {
                this.$refs.ownerWorkOrdersRef.pageChange(1);
            } else if (this.name == 'name3') {
                this.$refs.ownerActivityRef.pageChange(1);
            } else if (this.name == 'name4') {
                this.$refs.ownerQuestionnaireRef.pageChange(1);
            }
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        },
        onClickEdDel() {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {

                    abp.ajax.delete('/api/services/app/Owner/DeleteRoomAndOwner?ownerId=' + this.id).then(res => {

                        vm.$router.push({
                            name: 'ownerList'
                        });
                    }).finally(() => {

                    });

                }
            });
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        this.getOwnerById();
    }
};
